import * as React from 'react';
import { Path } from 'react-native-svg';
import { Icon, IIconProps } from 'native-base';

const SvgBank = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <Path d="M17.461 9.023c.604 0 .856-.776.366-1.133l-7.46-5.426a.621.621 0 00-.734 0L2.174 7.89c-.49.355-.238 1.133.367 1.133h1.21v7.305H2.343a.157.157 0 00-.156.156v1.015c0 .086.07.157.156.157h15.313c.085 0 .156-.07.156-.157v-1.015a.157.157 0 00-.156-.157H16.25V9.024h1.211zm-7.46-5.182l5.294 3.852H4.705L10 3.84zM5.156 9.023h2.285v7.305H5.157V9.023zm3.69 0h2.286v7.305H8.848V9.023zm5.997 7.305h-2.305V9.023h2.305v7.305z" />
    </Icon>
  );
};

export default SvgBank;
